import { render, staticRenderFns } from "./SaludOnline.vue?vue&type=template&id=62f58a8a&scoped=true&"
import script from "./SaludOnline.vue?vue&type=script&lang=js&"
export * from "./SaludOnline.vue?vue&type=script&lang=js&"
import style0 from "./SaludOnline.vue?vue&type=style&index=0&id=62f58a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f58a8a",
  null
  
)

export default component.exports